import React from 'react';
import styled from 'styled-components';
import { IconBrokenHeart, IconCheck } from '../Icon';

type Type = 'success' | 'error';

interface IIconAlterBoxProps {
  text: string;
  type: Type;
  onClick?: () => void;
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  padding: 16px;

  cursor: ${(props) => (!!props.onClick ? 'pointer' : 'cursor')};

  svg {
    flex: 0 0 50px;
  }

  &.success {
    background: ${(props) => props.theme.color.ui.success};
  }

  &.error {
    background: ${(props) => props.theme.color.ui.error};
    color: ${(props) => props.theme.color.ui.errorText};
  }
`;

const Aligner = styled.div`
  margin-top: 6px;
`;

const IconAlertBox = ({ text, type, onClick }: IIconAlterBoxProps) => {
  return (
    <Wrapper className={`color-inverted ${type}`} onClick={() => onClick && onClick()}>
      <Aligner>
        {type === 'success' && <IconCheck size="16px" />}
        {type === 'error' && <IconBrokenHeart size="16px" />}
      </Aligner>

      <p className="no-margin">{text}</p>
    </Wrapper>
  );
};

export default IconAlertBox;
